



















import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Route } from 'vue-router'
import { EventEmitter } from 'events'
import BaseTab from './baseTab'

enum EventTypes {
  CONFIRM_MODAL_REACT
}

@Component({
  components: {
    MedicationInstructionForm: () =>
      import(
        '@/components/medicationInstructionTab/MedicationInstructionForm.vue'
      ),
    AlertModal: () => import('@/components/common/modals/AlertModal.vue')
  }
})
export default class MedicationInstructionTab extends mixins(BaseTab) {
  @Prop(Number) patientId!: number

  events = new EventEmitter()
  pending = true
  isFormDirty = false
  showConfirmModal = false

  readonly CONFIRM_MESSAGE =
    '編集した内容は破棄されます。\n入力画面を離れますか？'

  handleEdit() {
    this.isFormDirty = true
  }

  handleReset() {
    this.isFormDirty = false
  }

  handleSave() {
    this.isFormDirty = false
  }

  handleReactConfirmModal(result: boolean) {
    this.events.emit(EventTypes.CONFIRM_MODAL_REACT, result)
  }

  handleBeforeUnload(event: any) {
    if (this.isFormDirty) {
      event.preventDefault()
      event.returnValue = this.CONFIRM_MESSAGE
      return this.CONFIRM_MESSAGE
    }
  }
  handleBeforeUnloadBind = this.handleBeforeUnload.bind(this)

  async created() {
    await this.$store.dispatch('medicationInstruction/fetchLatest', {
      patientId: this.patientId
    })
    this.pending = false
    window.addEventListener('beforeunload', this.handleBeforeUnloadBind)
  }

  destroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnloadBind)
  }

  async beforeRouteLeave(
    to: Route,
    from: Route,
    next: (cancel?: boolean) => void
  ) {
    if (!this.isFormDirty) {
      window.removeEventListener('beforeunload', this.handleBeforeUnloadBind)
      next()
      return
    }

    this.showConfirmModal = true
    const result = await new Promise<boolean>(resolve => {
      this.events.once(EventTypes.CONFIRM_MODAL_REACT, resolve)
    })
    this.showConfirmModal = false

    if (result) {
      window.removeEventListener('beforeunload', this.handleBeforeUnloadBind)
    }

    next(result)
  }
}
